document.addEventListener('DOMContentLoaded', function() {
  // Interceptar todos los formularios de agregar al carrito
  document.querySelectorAll('form[data-prevent-redirect]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const submitButton = form.querySelector('[type="submit"]');
      const originalText = submitButton.textContent;
      
      submitButton.disabled = true;
      submitButton.textContent = 'Agregando...';

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Object.fromEntries(formData))
      })
      .then(response => response.json())
      .then(data => {
        submitButton.textContent = 'Agregado a la Cesta';
        
        // Actualizar el contador del carrito
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            document.getElementById('cart-item-count').textContent = cart.item_count;
          });

        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        submitButton.textContent = 'Error';
        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }, 2000);
      });

      return false;
    });
  });
});
